module.exports = __webpack_public_path__ + "static/img/a2.2269c0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/a2.jpg
// module id = 56eh
// module chunks = 4